/**
 * Catálogo numérico de transiciones para el shader.
 * Los IDs coinciden con los enum de FFmpeg xfade para mantener un solo
 * identificador entre cliente y servidor.
 */

export const TRANSITION_ID: Record<string, number> = {
  fade: 0,
  wipeleft: 1,
  wiperight: 2,
  wipeup: 3,
  wipedown: 4,
  slideleft: 5,
  slideright: 6,
  slideup: 7,
  slidedown: 8,
  circlecrop: 9,
  rectcrop: 10,
  distance: 11,
  fadeblack: 12,
  fadewhite: 13,
  radial: 14,
  smoothleft: 15,
  smoothright: 16,
  smoothup: 17,
  smoothdown: 18,
  circleopen: 19,
  circleclose: 20,
  vertopen: 21,
  vertclose: 22,
  horzopen: 23,
  horzclose: 24,
  dissolve: 25,
  pixelize: 26,
  diagtl: 27,
  diagtr: 28,
  diagbl: 29,
  diagbr: 30,
  hlslice: 31,
  hrslice: 32,
  vuslice: 33,
  vdslice: 34,
  hblur: 35,
  fadegrays: 36,
  wipetl: 37,
  wipetr: 38,
  wipebl: 39,
  wipebr: 40,
  squeezeh: 41,
  squeezev: 42,
  zoomin: 43,
  fadefast: 44,
  fadeslow: 45,
  hlwind: 46,
  hrwind: 47,
  vuwind: 48,
  vdwind: 49,
  coverleft: 50,
  coverright: 51,
  coverup: 52,
  coverdown: 53,
  revealleft: 54,
  revealright: 55,
  revealup: 56,
  revealdown: 57,
  // gl-transitions extras (>= 100)
  burn: 100,
  glitch: 101,
  morph: 102,
  swirl: 103,
  ripple: 104,
  doorway: 105,
  kaleidoscope: 106,
  pageCurl: 107,
  // Patrones
  crosshatch: 108,
  mosaic: 109,
  polkadot: 110,
  hexagons: 111,
  diamonds: 112,
  scanlines: 113,
  // Formas
  squareWipe: 114,
  starWipe: 115,
  plusWipe: 116,
  heart: 117,
  letterbox: 118,
  circleWaves: 119,
  // Blur / Distorsión
  dreamyZoom: 120,
  linearBlur: 121,
  zoomBlur: 122,
  stretchBlur: 123,
  waterdrop: 124,
  noiseScramble: 125,
  rotateScale: 126,
  // Persianas / Grid
  windowblindsH: 127,
  windowblindsV: 128,
  shutterhorz: 129,
  shuttervert: 130,
  gridflip: 131,
  // Glitch / FX TV
  filmburnPro: 132,
  glitchHard: 133,
  invertFlash: 134,
  rgbSplit: 135,
};

/**
 * Resuelve el id de transición a algo que el compositor entiende:
 *  - number → shader compartido (xfade builtin + extras GLSL)
 *  - string → compositor dinámico (gl-transitions library)
 *  - 0      → fallback (fade)
 */
export function transitionIdOf(name: string | null | undefined): number | string {
  if (!name) return 0;
  // Si el id está en el catálogo dinámico, devolvemos el string directamente.
  // (lo detecta el compositor con isDynamicTransition.)
  // El shader compartido tiene prioridad si ambos definen el mismo id.
  const builtin = TRANSITION_ID[name as keyof typeof TRANSITION_ID];
  if (builtin !== undefined) return builtin;
  return name;  // delega al compositor dinámico (que validará)
}
